export default "__VITE_ASSET__tHjfoVlO__"